export default "__VITE_ASSET__DtyfVZcK__"